/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useLayoutEffect, useRef, useState } from 'react'

function DropDown({
  items,
  selectedItem,
  handleSelect,
  ref,
}: {
  items: any[]
  selectedItem: any
  handleSelect?: Function
  ref?: any
}) {
  const [open, setOpen] = useState(false)
  const [modalLeftPosition, setModalLeftPosition] = useState(0)
  const modalRef = useRef<HTMLInputElement>(null)
  const menuItemRef = useRef<HTMLButtonElement>(null)

  const [menuItemRect, setMenuItemRect] = useState({
    width: 0,
    left: 0,
    right: 0,
  })

  useLayoutEffect(() => {
    if (modalRef.current) {
      const modalRect = modalRef.current.getBoundingClientRect()

      const margin =
        window.innerWidth > 1440 ? (window.innerWidth - 1440) / 2 : 0

      const menuItemRightRef = window.innerWidth - menuItemRect.right

      const modalSize = modalRect.width / 2

      const modalLeft =
        menuItemRect.left - modalSize + menuItemRect.width / 2 - margin

      if (menuItemRightRef < modalSize) {
        setModalLeftPosition(menuItemRect.right - modalRect.width)
      } else if (modalLeft < 0) {
        setModalLeftPosition(10)
      } else {
        setModalLeftPosition(modalLeft)
      }
    }
  }, [open])

  const handleOpen = () => {
    setOpen(!open)
    if (open) {
      setMenuItemRect({
        width: 0,
        left: 0,
        right: 0,
      })
      setModalLeftPosition(0)
    } else if (menuItemRef.current) {
      setMenuItemRect(menuItemRef.current.getBoundingClientRect())
    }
  }

  const handleClick = (item) => {
    if (handleSelect) {
      handleSelect(item)
    }
  }

  return (
    <div ref={ref}>
      <button
        ref={menuItemRef}
        onClick={() => {
          handleOpen()
        }}
      >
        <div className="flex gap-1 text-sm items-center border-dark-grey text-dark-grey hover:border-engineering-grey-1 hover:text-engineering-grey-1 border-[1.5px] rounded-[5px] px-[10px] py-[6px] bg-white">
          {selectedItem.Name}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="6"
            viewBox="0 0 10 6"
            fill="none"
          >
            <path
              d="M8.93248 0H1.06752C0.643602 0 0.412023 0.494428 0.68341 0.820091L4.61589 5.53907C4.81579 5.77894 5.18421 5.77894 5.38411 5.53907L9.31659 0.820092C9.58798 0.494429 9.3564 0 8.93248 0Z"
              fill="#33333C"
            />
          </svg>
        </div>
      </button>

      {open && (
        <div
          className="absolute shadow w-[100px]  bg-white mt-4 isolate"
          ref={modalRef}
          style={{ left: modalLeftPosition }}
        >
          <ul className="bg-white ">
            {items.map((item) => (
              <li
                key={item.Name}
                onClick={() => handleClick(item)}
                className=" px-4 py-[13px] border-b-[1px] border-separators-grey last:border-b-white hover:bg-engineering-grey-4 "
              >
                <div className="flex justify-between text-sm">
                  {item.Name}
                  {item === selectedItem && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <path
                        d="M0.929688 7L5.12969 12.0313L13.1214 2.625"
                        stroke="black"
                        stroke-width="2"
                      />
                    </svg>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

export default DropDown
